import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';



import { AppComponent } from './app.component';
//import { AuthGuard } from './guards/auth.guard;
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { HomeComponent } from './home/home.component';
import { CounterComponent } from './counter/counter.component';

import { ApiAuthorizationModule } from 'src/api-authorization/api-authorization.module';
import { AuthorizeGuard } from 'src/api-authorization/authorize.guard';
import { AuthorizeInterceptor } from 'src/api-authorization/authorize.interceptor';
import { AdalService, AdalGuard, AdalInterceptor } from '../../node_modules/adal-angular4';
import { EnvironmentUrlService } from './shared/services/environment-url.service';
import { RepositoryService } from './shared/services/repository.service';

import { NgbModule } from '../../node_modules/@ng-bootstrap/ng-bootstrap';

// Import angular-fusioncharts
import { FusionChartsModule } from "../../node_modules/angular-fusioncharts";

// Import FusionCharts library and chart modules
import * as FusionCharts from '../../node_modules/fusioncharts';
import * as Charts from '../../node_modules/fusioncharts/fusioncharts.charts';
import * as PowerCharts from '../../node_modules/fusioncharts/fusioncharts.powercharts';

import * as FusionTheme from '../../node_modules/fusioncharts/themes/fusioncharts.theme.fusion';
import { MitigationEditorComponent } from "./risk/mitigation-editor/mitigation-editor.component";
import { RiskModule } from "./risk/risk.module";
import { AlertComponent } from './alert/alert.component';
import { AlertService } from './shared/services/alert.service';
import { RuntimeConfigService } from './shared/services/runtime-config.service';


// Pass the fusioncharts library and chart modules
FusionChartsModule.fcRoot(FusionCharts, Charts, FusionTheme, PowerCharts);

export function initializeRuntimeConfig(runtimeConfigService: RuntimeConfigService) {
    return () => runtimeConfigService.load();
}


@NgModule({
    declarations: [
        AppComponent,
        NavMenuComponent,
        HomeComponent,
        CounterComponent,
        AlertComponent

    ],
    imports: [
        BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
      HttpClientModule,
      RiskModule,
        FormsModule,
        NgbModule,
        FusionChartsModule,
        ApiAuthorizationModule,
        RouterModule.forRoot([
            { path: '', component: HomeComponent, pathMatch: 'full' },
            { path: 'counter', component: CounterComponent },
            { path: 'myrisks', loadChildren: "./risk/risk.module#RiskModule", canActivate: [AdalGuard] }, // , canActivate: [AdalGuard]
        ])
    ],
    providers: [AdalService, AdalGuard, EnvironmentUrlService, RepositoryService, AlertService, NgbModule, RuntimeConfigService,
        { provide: APP_INITIALIZER, useFactory: initializeRuntimeConfig, deps: [RuntimeConfigService], multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: AdalInterceptor, multi: true },
        { provide: LOCALE_ID, useValue: 'en-GB' }
    ],
    bootstrap: [AppComponent],
 
})
export class AppModule { }
